import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../data/static/strings'
import { fromDateTime, toDateTime, updateEndDateTimeInForBeneficiaryFileList } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (response: any) => {
  return {
    response: response,
    page: {
      size: response?.data?.size,
      totalElements: response?.data?.totalElements,
      totalPages: response?.data?.totalPages,
      number: response?.data?.totalElements === 0 ? 1 : response?.data?.pageNo,
    },
  }
}

const bulkBeneficiaryFileHistory = (
  tokens: any,
  type: string,
  page: number,
  size: number,
  selectedDateInfo: any,
  mid: string,
) => {
  const isCustomRange =
    selectedDateInfo?.dateLabel === actionMenuStrings.customDate || selectedDateInfo?.dateLabel === 'custom'
  let body = {
    type: type,
    pageNo: page,
    size: size,
    toDate: toDateTime(selectedDateInfo.toDate),
    fromDate: fromDateTime(selectedDateInfo.fromDate),
    mid,
  }
  body = isCustomRange ? body : updateEndDateTimeInForBeneficiaryFileList(body, selectedDateInfo.dateLabel)
  const request: Request<{}> = {
    apiPath: APIEndPoints.bulkBeneficiaryUploadList,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    body,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { bulkBeneficiaryFileHistory }
